import React from "react";
import {FiAlertCircle} from "@react-icons/all-files/fi/FiAlertCircle";

interface FormInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    label?: string,
    hideLabel?: boolean,
    error?: string,
    rootClassName?: string
}

const FormInput = (props: FormInputProps) => {

    const inputProps = {...props};
    delete inputProps.label
    delete inputProps.hideLabel
    delete inputProps.error
    delete inputProps.rootClassName

    const focusRing = !!props.error ? "focus:ring-red-400" : "focus:ring-zinc-800";
    const focusBorder = !!props.error ? "focus:border-red-400" : "focus:border-lime-300"

    return (
        <div className={`${props.rootClassName}`}>
            <label htmlFor={inputProps.id} className={props.hideLabel ? "sr-only" : "text-xs tracking-widest uppercase font-bold font-display opacity-80"}>
                {props.label}
            </label>
            <div className={`relative -space-y-px rounded-md shadow-sm`}>
                <input {...inputProps}
                       className={`font-body text-base transition duration-200 appearance-none relative block w-full px-3 py-2 border ${props.error ? "border-red-300 z-10" : "border-gray-300"} placeholder-gray-500 text-gray-900 focus:outline-none ${focusBorder} focus:ring-1 ${focusRing} ${props.className} rounded-md`}
                       style={{ background: "#f7f8f2" }}
                       disabled={props.disabled}
                />
                {(!!props.error) &&
                <div className={"absolute z-10 right-3 top-1/2 transform -translate-y-1/2"}>
                    <FiAlertCircle className={"text-red-700"} size={14}/>
                </div>
                }
            </div>
            {(!!props.error && props.error !== "empty") &&
                <p style={{ textTransform:"none"}} className={"-space-y-px text-sm mt-1 text-red-700"}>
                    {props.error}
                </p>
            }
        </div>
    )

}

export default FormInput;